import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/info.svg'
import _imports_1 from '@/assets/dosis.svg'
import _imports_2 from '@/assets/chevron-down.svg'


const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "row gx-0 gx-xl-5 gy-4 mb-4 flex-row-reverse" }
const _hoisted_16 = { class: "info-box col-12 col-xl-3 p-4" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "calculator col-12 col-xl-9" }
const _hoisted_20 = { class: "row gx-0 gy-4 gy-md-0" }
const _hoisted_21 = { class: "calc-input col-12 col-md-6 p-0 p-md-4" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "input-group input-group-lg" }
const _hoisted_25 = ["aria-label"]
const _hoisted_26 = { class: "invalid-feedback" }
const _hoisted_27 = {
  class: "info-text clickable",
  "data-bs-toggle": "modal",
  "data-bs-target": "#expense-modal"
}
const _hoisted_28 = ["alt"]
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "input-group input-group-lg" }
const _hoisted_32 = ["aria-label"]
const _hoisted_33 = { class: "invalid-feedback" }
const _hoisted_34 = {
  class: "info-text clickable",
  "data-bs-toggle": "modal",
  "data-bs-target": "#subsidiary-modal"
}
const _hoisted_35 = ["alt"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col" }
const _hoisted_38 = ["aria-label"]
const _hoisted_39 = {
  value: "NONE",
  hidden: "",
  selected: ""
}
const _hoisted_40 = { value: "NOT_MEMBER" }
const _hoisted_41 = { value: "INACTIVE_MEMBER" }
const _hoisted_42 = { value: "GROUP_1" }
const _hoisted_43 = { value: "GROUP_2" }
const _hoisted_44 = { value: "GROUP_5" }
const _hoisted_45 = {
  class: "info-text clickable",
  "data-bs-toggle": "modal",
  "data-bs-target": "#insurance-modal"
}
const _hoisted_46 = ["alt"]
const _hoisted_47 = { class: "calc-result col-12 col-md-6 p-4" }
const _hoisted_48 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_49 = ["alt"]
const _hoisted_50 = {
  key: 1,
  class: "results",
  ref: "results"
}
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "result-header" }
const _hoisted_53 = { class: "result-text" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "result-header" }
const _hoisted_56 = { class: "result-text" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "result-header" }
const _hoisted_59 = { class: "result-text" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "disclaimer" }
const _hoisted_62 = {
  key: 0,
  class: "scroll-to-prices position-fixed bottom-0 start-50 translate-middle-x"
}
const _hoisted_63 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Collapsible = _resolveComponent("Collapsible")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_observe_visibility = _resolveDirective("observe-visibility")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Modal, {
      id: "expense-modal",
      title: _ctx.$t('yearly_expense_modal_title')
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          class: "mb-0",
          innerHTML: _ctx.tl('yearly_expense_modal_text_before_list')
        }, null, 8, _hoisted_1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            innerHTML: _ctx.tl('yearly_expense_modal_text_li_0')
          }, null, 8, _hoisted_2),
          _createElementVNode("li", {
            innerHTML: _ctx.tl('yearly_expense_modal_text_li_1')
          }, null, 8, _hoisted_3),
          _createElementVNode("li", {
            innerHTML: _ctx.tl('yearly_expense_modal_text_li_2')
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("p", {
          innerHTML: _ctx.tl('yearly_expense_modal_text_after_list')
        }, null, 8, _hoisted_5),
        _createVNode(_component_Collapsible, {
          "text-collapsed": _ctx.$t('ctr_thresholds_button_show'),
          "text-open": _ctx.$t('ctr_thresholds_button_hide')
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('ctr_thresholds_title')), 1),
            _createElementVNode("table", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCurrentCtrThresholdPeriod().thresholds, (threshold, index) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_6, " Under " + _toDisplayString(_ctx.$n(threshold.max, 'currency')), 1))
                    : (index === _ctx.getCurrentCtrThresholdPeriod().thresholds.length - 1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_7, " Over " + _toDisplayString(_ctx.$n(threshold.min, 'currency')), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(_ctx.$n(threshold.min, 'currency')) + " - " + _toDisplayString(_ctx.$n(threshold.max, 'currency')), 1)),
                  _createElementVNode("td", null, _toDisplayString(threshold.factor * 100) + "% tilskud", 1)
                ]))
              }), 256))
            ])
          ]),
          _: 1
        }, 8, ["text-collapsed", "text-open"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_Modal, {
      id: "subsidiary-modal",
      title: _ctx.$t('health_subsidiary_modal_title')
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          innerHTML: _ctx.tl('health_subsidiary_modal_text')
        }, null, 8, _hoisted_9)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_Modal, {
      id: "insurance-modal",
      title: _ctx.$t('insurance_modal_title')
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          innerHTML: _ctx.tl('insurance_modal_text')
        }, null, 8, _hoisted_10)
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: _normalizeClass(["col mt-3 mb-4", {'mt-5': !_ctx.appWebview}])
        }, [
          (!_ctx.appWebview)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_13, _toDisplayString(_ctx.$t('header_title')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('header_text')
          }, null, 8, _hoisted_14)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('info_box_title')), 1),
          _createElementVNode("p", {
            class: "p-1",
            innerHTML: _ctx.$t('info_box_text')
          }, null, 8, _hoisted_17),
          _createElementVNode("a", {
            class: "btn btn-primary w-100",
            href: _ctx.$t('info_box_button_link'),
            target: "_blank"
          }, _toDisplayString(_ctx.$t('info_box_button_text')), 9, _hoisted_18)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("form", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('yearly_expense_title')) + " ", 1),
                  _createElementVNode("div", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["form-control", {'is-invalid': _ctx.yearlyExpenseInvalid}]),
                      type: "number",
                      min: "0",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearlyExpense) = $event)),
                      required: "",
                      ref: "yearlyExpenseInput",
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.$refs.healthSubsidiaryInput.focus && _ctx.$refs.healthSubsidiaryInput.focus(...args)), ["enter"])),
                      onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isNumber($event))),
                      "aria-label": _ctx.$t('yearly_expense_alt_label'),
                      "aria-describedby": "yearly-expense"
                    }, null, 42, _hoisted_25), [
                      [_vModelText, _ctx.yearlyExpense]
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("span", {
                      class: "input-group-text",
                      id: "yearly-expense"
                    }, "kr.", -1)),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('input_invalid_label')) + " ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("img", {
                      class: "me-1",
                      src: _imports_0,
                      alt: _ctx.$t('input_help_alt_label'),
                      width: "28",
                      height: "28"
                    }, null, 8, _hoisted_28),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('input_help_label')) + " ", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('health_subsidiary_title')) + " ", 1),
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["form-control", {'is-invalid': _ctx.healthSubsidiaryInvalid}]),
                      type: "number",
                      min: "0",
                      max: "85",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.healthSubsidiary) = $event)),
                      required: "",
                      ref: "healthSubsidiaryInput",
                      onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.$refs.insuranceInput.focus && _ctx.$refs.insuranceInput.focus(...args)), ["enter"])),
                      onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isNumber($event))),
                      "aria-label": _ctx.$t('health_subsidiary_alt_label'),
                      "aria-describedby": "health-subsidiary"
                    }, null, 42, _hoisted_32), [
                      [_vModelText, _ctx.healthSubsidiary]
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("span", {
                      class: "input-group-text",
                      id: "health-subsidiary"
                    }, "%", -1)),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('input_invalid_label')) + " ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("img", {
                      class: "me-1",
                      src: _imports_0,
                      alt: _ctx.$t('input_help_alt_label'),
                      width: "28",
                      height: "28"
                    }, null, 8, _hoisted_35),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('input_help_label')) + " ", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('insurance_title')) + " ", 1),
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select form-select-lg", {unselected: _ctx.insurance === null}]),
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.insurance) = $event)),
                    required: "",
                    ref: "insuranceInput",
                    "aria-label": _ctx.$t('insurance_alt_label'),
                    "aria-required": "true"
                  }, [
                    _createElementVNode("option", _hoisted_39, _toDisplayString(_ctx.$t('insurance_option_null')), 1),
                    _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.$t('insurance_option_not_member')), 1),
                    _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.$t('insurance_option_inactive_member')), 1),
                    _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.$t('insurance_option_group_1')), 1),
                    _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t('insurance_option_group_2')), 1),
                    _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t('insurance_option_group_5')), 1)
                  ], 10, _hoisted_38), [
                    [_vModelSelect, _ctx.insurance]
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("img", {
                      class: "me-1",
                      src: _imports_0,
                      alt: _ctx.$t('input_help_alt_label'),
                      width: "28",
                      height: "28"
                    }, null, 8, _hoisted_46),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('input_help_label')) + " ", 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              (_ctx.yearlyExpense === null || _ctx.healthSubsidiary === null || _ctx.insurance === 'NONE' || _ctx.yearlyExpenseInvalid || _ctx.healthSubsidiaryInvalid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("img", {
                      class: "mb-4",
                      src: _imports_1,
                      alt: _ctx.$t('empty_state_icon_alt'),
                      width: "125",
                      height: "132"
                    }, null, 8, _hoisted_49),
                    _createElementVNode("p", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('empty_state_text')), 1)
                    ])
                  ]))
                : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('expense_daily_label')), 1),
                      _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$n(_ctx.daily, 'currencyDecimal')), 1)
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1)),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('expense_fortnightly_label')), 1),
                      _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$n(_ctx.fortnightly, 'currencyDecimal')), 1)
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('expense_yearly_label')), 1),
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$n(_ctx.yearly, 'currencyDecimal')), 1)
                    ])
                  ])), [
                    [_directive_observe_visibility, {callback: _ctx.resultVisibilityChanged, intersection: {threshold: 0.20}}]
                  ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("p", _hoisted_61, " * " + _toDisplayString(_ctx.$t('disclaimer_text')), 1)
      ]),
      _createVNode(_Transition, { name: "slide" }, {
        default: _withCtx(() => [
          (_ctx.showScrollButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                _createElementVNode("div", {
                  class: "info-text clickable",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$refs.results.scrollIntoView({block: 'center', inline: 'center'})))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('scroll_to_prices_text')) + " ", 1),
                  _createElementVNode("img", {
                    class: "me-1",
                    src: _imports_2,
                    alt: _ctx.$t('scroll_to_prices_text')
                  }, null, 8, _hoisted_63)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 64))
}